var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { State, namespace } from "vuex-class";
import { Emit, Prop } from "vue-property-decorator";
import { UserService } from "~/services/management-service/user.service";
import FlieUpload from "~/components/common/file-upload.vue";
import { CaseRepaymentService } from "~/services/domain-service/case-repayment.service";
import RepaymentReceiveDetail from './repayment-receive-detail.vue';
var CollectionExecutionModule = namespace('collection-execution');
var Repayment = /** @class */ (function (_super) {
    __extends(Repayment, _super);
    function Repayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fromData = {
            caseTaskId: "",
            caseNumber: "",
            collectorId: "",
            collectorRealName: "",
            paymentType: "",
            receiveAcctname: "",
            receiveAcctno: "",
            entryTime: "",
            repayAmount: "",
            repaymentAcctname: "",
            repaymentAcctno: "",
            deptId: "",
            deptCode: "",
            deptName: "",
            imageUrl: [],
            remark: ''
        };
        _this.dialog = false;
        _this.dataSet = [];
        _this.selectionList = [];
        _this.fileList = [];
        //数据校验
        _this.rules = {
            caseTaskId: [
                { required: true, message: "订单id不能为空", trigger: "blur" }
            ],
            paymentType: [
                { required: true, message: "请选择收款方式", trigger: "blur" }
            ],
            receiveAcctname: [
                { required: true, message: "请输入收款账户", trigger: "blur" }
            ],
            receiveAcctno: [
                { required: true, message: "请输入收款账号", trigger: "blur" }
            ],
            entryTime: [{ required: true, message: "请选择回款日期", trigger: "blur" }],
            repayAmount: [
                { required: true, message: "请输入回款金额", trigger: "blur" }
            ],
            repaymentAcctname: [
                { required: true, message: "请输入回款账户", trigger: "blur" }
            ],
            repaymentAcctno: [
                { required: true, message: "请输入回款账号", trigger: "blur" }
            ]
        };
        _this.userList = [];
        return _this;
    }
    Repayment.prototype.EmitClose = function () {
        this.reset();
    };
    Repayment.prototype.getInfo = function () {
        this.getAllUserList();
        this.fromData.collectorId = this.userData.id;
        this.fromData.collectorRealName = this.userData.realName;
        this.fromData.deptId = this.userData.deptId;
        this.fromData.deptCode = this.userData.deptCode;
        this.fromData.deptName = this.userData.deptName;
        this.fromData.caseTaskId = this.caseIds[0];
        this.fromData.caseNumber = this.caseNumbers[0];
    };
    Repayment.prototype.commit = function () {
        var _this = this;
        var form = this.$refs["repayment-form"];
        form.validate(function (valid) {
            if (!valid)
                return false;
            _this.fileList.forEach(function (element) {
                if (element.response) {
                    _this.fromData.imageUrl.push(element.response.id);
                }
            });
            _this.caseRepaymentService
                .addCaseRepaymentApply(_this.fromData)
                .subscribe(function (data) {
                _this.$message.success("还款申请成功");
                _this.EmitClose();
                _this.onFollowSuccess();
            });
        });
    };
    Repayment.prototype.changeDept = function (val) {
        var _this = this;
        this.userList.forEach(function (item) {
            if (item.id === val) {
                _this.fromData.collectorId = item.id;
                _this.fromData.collectorRealName = item.realName;
                _this.fromData.deptId = item.deptId;
                _this.fromData.deptCode = item.deptCode;
                _this.fromData.deptName = item.deptName;
            }
        });
    };
    Repayment.prototype.getReceiveAccount = function (val) {
        var _this = this;
        this.fromData.receiveAcctname = '';
        this.fromData.receiveAcctno = '';
        this.caseRepaymentService.getReceiveAccount(val, this.fromData.caseTaskId).subscribe(function (data) {
            if (data.length > 1) {
                _this.dataSet = data;
                _this.dialog = true;
                _this.$nextTick(function () {
                    var from = _this.$refs['repayment-receive-detail'];
                    from.selectionList = [];
                });
            }
            else {
                _this.fromData.receiveAcctname = data.length && data[0].gatheringAccount || '';
                _this.fromData.receiveAcctno = data.length && data[0].gatheringAccountNo || '';
            }
        });
    };
    /**
     * 成功后更新历史纪录面板
     */
    Repayment.prototype.onFollowSuccess = function () {
        var _this = this;
        this.updateHistoryInfoActive("");
        this.updateAddRecordFlag(true);
        this.$nextTick(function () {
            _this.updateHistoryInfoActive('repay-records');
        });
    };
    Repayment.prototype.getAllUserList = function () {
        var _this = this;
        this.userService
            .getAllUsersList({ userStatus: "ENABLED" })
            .subscribe(function (data) {
            _this.userList = data;
        });
    };
    Repayment.prototype.onUploadRemove = function (file, fileList) {
        this.fileList = fileList;
    };
    //重置方法
    Repayment.prototype.reset = function () {
        var modifyForm = this.$refs["repayment-form"];
        modifyForm.resetFields();
        this.fileList = [];
    };
    __decorate([
        Dependencies(UserService)
    ], Repayment.prototype, "userService", void 0);
    __decorate([
        Dependencies(CaseRepaymentService)
    ], Repayment.prototype, "caseRepaymentService", void 0);
    __decorate([
        State
    ], Repayment.prototype, "userData", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], Repayment.prototype, "updateHistoryInfoActive", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], Repayment.prototype, "updateAddRecordFlag", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], Repayment.prototype, "caseIds", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], Repayment.prototype, "caseNumbers", void 0);
    __decorate([
        Emit("close")
    ], Repayment.prototype, "EmitClose", null);
    Repayment = __decorate([
        Component({
            components: {
                FlieUpload: FlieUpload,
                RepaymentReceiveDetail: RepaymentReceiveDetail
            }
        })
    ], Repayment);
    return Repayment;
}(Vue));
export default Repayment;
